import axios, { AxiosInstance, AxiosRequestHeaders } from 'axios';

export const getVoteApiObj = (): AxiosInstance => {
    const headers: AxiosRequestHeaders = {
        'Content-Type': 'application/json',
    };

    return axios.create({
        baseURL: process.env.REACT_APP_VOTE_API_BASEURL,
        headers,
    });
};
